<template>
  <FormContainer @submitForm="saveRicavo">
    <div class="row">
      <FormInputTextWidget
        class="col-lg-4 col-sm-6"
        label="Nome del ricavo"
        v-model="ricavo.name"
        :errorMsg="errorHash['name']"
        @input="removeError('name')"
      />

      <FormInputSelectWidget
        class="col-lg-4 col-sm-6"
        label="Tipologia di ricavo"
        v-model="ricavo.tipoRicavoId"
        :options="tipoRicavoOptions"
        :errorMsg="errorHash['tipoRicavoId']"
        @input="removeError('tipoRicavoId')"
      />
    </div>

    <div class="row">
      <FormInputAmountWidget
        v-if="ricavo.tipoRicavoId === 1"
        class="col-lg-4 col-sm-6"
        label="Importo annuo"
        v-model.number="ricavo.importo"
        :min="0"
        :errorMsg="errorHash['importo']"
        @input="removeError('importo')"
      />

      <FormInputSelectWidget
        v-if="ricavo.tipoRicavoId === 1"
        class="col-lg-4 col-sm-6"
        label="Frequenza"
        v-model="ricavo.frequenza"
        :options="frequenze"
      />

      <FormInputTextWidget
        v-if="ricavo.tipoRicavoId === 2"
        class="col-lg-4 col-sm-6"
        label="Numero di pezzi annui"
        v-model="ricavo.nbPieces"
        :errorMsg="errorHash['nbPieces']"
        @input="removeError('nbPieces')"
      />

      <FormInputAmountWidget
        v-if="ricavo.tipoRicavoId === 2"
        class="col-lg-4 col-sm-6"
        label="Ricavo per pezzo"
        v-model.number="ricavo.piecePrice"
        :min="0"
        :errorMsg="errorHash['piecePrice']"
        @input="removeError('piecePrice')"
      />
    </div>

    <div class="row">
      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Aliquota IVA"
        v-model.number="ricavo.vat"
        :errorMsg="errorHash['vat']"
        @input="removeError('vat')"
      />

      <FormInputPercentageWidget
        class="col-lg-4 col-sm-6"
        label="Variazione annuale"
        v-model.number="ricavo.delta"
        :errorMsg="errorHash['delta']"
        @input="removeError('delta')"
      />

      <FormInputSelectDilazioneWidget
        class="col-lg-4 col-sm-6"
        label="Giorni di dilazione"
        v-model.number="ricavo.dilazione"
        :errorMsg="errorHash['dilazione']"
        @input="removeError('dilazione')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Mese del primo ricavo"
        v-model="ricavo.begin"
        :errorMsg="errorHash['begin']"
        @input="removeError('begin')"
      />

      <FormInputMonthPickerWidget
        class="col-lg-4 col-sm-6"
        label="Ultimo mese del ricavo"
        not-required
        v-model="ricavo.end"
        :errorMsg="errorHash['end']"
        @input="removeError('end')"
      />
    </div>

    <div class="row">
      <div class="col-12 mt-4 text-center text-sm-right">
        <button class="btn btn-primary" type="submit">
          <i class="fas fa-save mr-2"></i>
          Salva ricavo
        </button>
      </div>
    </div>
  </FormContainer>
</template>

<script>

import validateMixin from '@/libs/Form/mixins/validate';

export default {
  name: 'operative-form-cost',
  mixins: [validateMixin],
  components: {
    FormContainer: () => import('@/libs/Form/components/FormContainer'),
    FormInputTextWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputAmountWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputAmountWidget'),
    FormInputPercentageWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputPercentageWidget'),
    FormInputSelectWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputMonthPickerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputMonthPickerWidget'),
    FormInputSelectDilazioneWidget: () => import('./Widgets/FormInputSelectDilazioneWidget'),
  },
  props: {
    ricavo: {
      type: Object,
      default: () => ({
        name: null,
        importo: null,
        nbPieces: null,
        piecePrice: null,
        frequenza: 1,
        vat: 22,
        delta: 0,
        dilazione: 0,
        begin: null,
        end: null,
        tipoRicavoId: 1,
      }),
    },
    frequenze: {
      type: Array,
      default: () => [
        { value: 1, label: 'Mensile' },
        { value: 2, label: 'Bimensile' },
        { value: 3, label: 'Trimestrale' },
        { value: 4, label: 'Semestrale' },
        { value: 5, label: 'Annuale' },
      ],
    },
    tipoRicavoOptions: {
      type: Array,
      default: () => [
        { value: 1, label: 'A corpo' },
        { value: 2, label: 'A unità' },
      ],
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    validate () {
      this.clearErrors();

      if (!this.ricavo.name) {
        this.addError('Il nome del ricavo è obbligatorio', 'name');
      }

      if (this.ricavo.tipoRicavoId === 1 && !this.ricavo.tipoRicavoId) {
        this.addError('La tipologia del ricavo è obbligatoria', 'tipoRicavoId');
      }

      if (this.ricavo.tipoRicavoId === 1 && !this.ricavo.importo) {
        this.addError('L\'importo del ricavo è obbligatorio', 'importo');
      }

      if (this.ricavo.tipoRicavoId === 2 && !this.ricavo.nbPieces) {
        this.addError('Il numero di pezzi per anno è obbligatorio', 'nbPieces');
      }

      if (this.ricavo.tipoRicavoId === 2 && !this.ricavo.piecePrice) {
        this.addError('L\'importo del ricavo per pezzo è obbligatorio', 'piecePrice');
      }

      if (!this.ricavo.vat && this.ricavo.vat !== 0) {
        this.addError('L\'aliquota IVA è obbligatoria', 'vat');
      }

      if (!this.ricavo.delta && this.ricavo.delta !== 0) {
        this.addError('La variazione annuale è obbligatoria', 'delta');
      }

      if (!this.ricavo.begin) {
        this.addError('Il mese del primo ricavo è obbligatorio', 'begin');
      }

      if (this.ricavo.end && this.ricavo.end < this.ricavo.begin) {
        this.addError('Il mese dell\'ultimo mese deve essere successivo al primo', 'end');
      }

      return !this.hasErrors;
    },
    saveRicavo () {
      if (!this.validate()) {
        return;
      }

      this.$emit('saved', this.ricavo);
    },
  },
};

</script>
